import React, { useState, useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SalesStyle from './css/SalesStyle'
import DailySalesController from './reports/dailysales/DailySalesController'
import MonthlySalesController from './reports/monthlysales/MonthlySalesController'
import YearlySalesController from './reports/yearlysales/YearlySalesController'
import ReceivablesController from './reports/receivables/ReceivablesController'
import { appContext } from '../../../../App'

function Sales() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const [showHeader, setShowHeader] = useState(true)

  const onClickHeader = (e) => { setShowHeader(!showHeader) }

  const onClickDailySales = (e) => { setContent(<DailySalesController />)}

  const onClickMonthlySales = (e) => { setContent(<MonthlySalesController />) }

  const onClickYearlySales = (e) => { setContent(<YearlySalesController />) }

  const onClickReceivables = (e) => { setContent(<ReceivablesController />) }

  return (
    <React.Fragment>
      <div className='report-item-container'>
        <button id='sales' onClick={onClickHeader} className='report-item-header'>
          Sales &nbsp;<span style={{marginTop: '2px'}}><FontAwesomeIcon icon={(showHeader) ? 'caret-down' : 'caret-right'}/></span>
        </button>
        <div className={(showHeader) ? 'report-items-container' : 'hide-ric'}>
          <button
            id='daily-sales-btn'
            onClick={onClickDailySales}
            className='report-item-wrapper'>
            <div className='report-item-title'>Daily Sales</div>
            <div className='report-item-description'>
            Daily sales report in a month
            </div>
          </button>
          <button
            id='monthly-sales-btn'
            onClick={onClickMonthlySales}
            className='report-item-wrapper'>
            <div className='report-item-title'>Monthly Sales</div>
            <div className='report-item-description'>
            Monthly & quarterly sales report in a year
            </div>
          </button>
          <button
            id='yearly-sales-btn'
            onClick={onClickYearlySales}
            className='report-item-wrapper'>
            <div className='report-item-title'>Yearly Sales</div>
            <div className='report-item-description'>
            10 years back sales report
            </div>
          </button>
          <button
            id='receivables-btn'
            onClick={onClickReceivables}
            className='report-item-wrapper'>
            <div className='report-item-title'>Receivables</div>
            <div className='report-item-description'>
            List of customers credit balances
            </div>
          </button>
        </div>
      </div>
      <SalesStyle signed_in={app.client.signed_in}/>
    </React.Fragment>
  )
}

export default React.memo(Sales)